/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import {
  Panel,
  Button,
  Table,
  OverlayTrigger,
  Tooltip,
} from 'react-bootstrap';
import DeleteModal from 'loracoms/DeleteModal';
import ShowIf from 'loracoms/ShowIf';
import Refresher from 'loracoms/Refresher';
import Copy from 'loracoms/Copy';
import IntlMsg from 'lorautils/intl/IntlMsg';
import broadcastActions from 'loraactions/broadcast';
import callAPI from '@/api/callAPI';
import EditAddress from '../EditAddress';
import AddAddress from '../AddAddress';
import styles from './styles.scss';

const propTypes = {
  intl: PropTypes.object.isRequired,
  appId: PropTypes.string.isRequired,
  getBroadcast: PropTypes.func.isRequired,
  broadcastState: PropTypes.object.isRequired,
};

class AddrList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      deleteAddr: {},
      showDeleteModal: false,
    };
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail.broadcast');
  }

  componentWillMount() {
    this.loadBrdcstAddr();
  }

  componentWillReceiveProps(nextProps) {
    const { broadcastState: { data, status } } = nextProps;
    if (data) {
      this.setState({
        list: _.map(data.list, l => ({ ...l, isNew: false })),
        status,
      });
    }
  }

  loadBrdcstAddr() {
    this.setState({ status: 'pending' });
    const { appId, getBroadcast } = this.props;
    getBroadcast(appId);
  }

  handleReload() {
    this.loadBrdcstAddr();
  }

  handleAdd(b) {
    const { list } = this.state;
    this.setState({ list: _.concat(b, list) });
  }

  handleEdit() {
    this.loadBrdcstAddr();
  }

  handleDelete() {
    const { deleteAddr, list } = this.state;
    const { appId } = this.props;
    if (deleteAddr.devaddr) {
      callAPI({
        endpoint: `/lora/apps/${appId}/broadcasts/${deleteAddr.devaddr}`,
        method: 'DELETE',
      }).then(() => {
        this.setState({
          list: _.filter(list, l => l.devaddr !== deleteAddr.devaddr),
          showDeleteModal: false,
        });
      }).catch(() => {});
    }
  }

  renderRows(list) {
    const tooltip1 = <Tooltip id="deleteaddr">{this.intlMsg.msg('addrlist.delete')}</Tooltip>;
    const tooltip2 = <Tooltip id="editaddr">{this.intlMsg.msg('addrlist.edit')}</Tooltip>;
    return _.map(list, l => (
      <tr
        key={l.devaddr}
        className={l.isNew ? styles.new : ''}
      >
        <td>{l.name}</td>
        <td>
          {l.devaddr}&nbsp;
          <Copy id={`copy-devaddr-${l.devaddr}`} text={l.devaddr} />
        </td>
        <td>
          {l.appskey ? `${l.appskey.substring(0, 6)}...` : ''}&nbsp;
          <Copy id={`copy-${l.appskey}`} text={l.appskey} />
        </td>
        <td>
          {l.nwkskey ? `${l.nwkskey.substring(0, 6)}...` : ''}&nbsp;
          <Copy id={`copy-${l.nwkskey}`} text={l.nwkskey} />
        </td>
        <td>{l.band}</td>
        <td>{l.rx2dr}</td>
        <td>{!_.isNil(l.rx2freq) ? Number(l.rx2freq / 10000).toFixed(4) : l.rx2freq}</td>
        <td>{l.fcntdown}</td>
        <td>
          <OverlayTrigger placement="top" overlay={tooltip1}>
            <Link
              className={styles.delete}
              onClick={() => {
                this.setState({ showDeleteModal: true, deleteAddr: l });
              }}
            >
              <span className="halflings halflings-trash" />
            </Link>
          </OverlayTrigger>
          <OverlayTrigger placement="top" overlay={tooltip2}>
            <Link
              onClick={() => {
                this.setState({ showEditModal: true, editObj: l });
              }}
            >
              <span className={`glyphicons glyphicons-pencil ${styles.edit}`} />
            </Link>
          </OverlayTrigger>
        </td>
      </tr>
    ));
  }

  render() {
    const {
      list,
      deleteAddr,
      editObj = {},
      status = 'idle',
      showDeleteModal,
      showModal = false,
      showEditModal = false,
    } = this.state;
    const { appId } = this.props;
    const header = (
      <div>
        {this.intlMsg.msg('addrlist.header')}
        <Button
          bsStyle="aisz-success"
          onClick={() => this.setState({ showModal: true })}
          className={styles.marginLm}
        >
          {this.intlMsg.msg('addrlist.address')}
          <span className={`glyphicon glyphicon-plus ${styles.marginLm}`} />
        </Button>
        <div className={`pull-right ${styles.gray}`}>
          <Refresher
            onReload={() => this.handleReload()}
            reloading={status === 'pending'}
          />
        </div>
      </div>
    );
    return (
      <div className={styles.fullHeight}>
        <Panel
          bsStyle="aisz-white"
          header={header}
          className={styles.fullHeight}
        >
          <Table
            className="aisz-table-light"
            bordered
            responsive
          >
            <thead>
              <tr>
                <th>{this.intlMsg.msg('addrlist.name')}</th>
                <th>{this.intlMsg.msg('addrlist.address')}</th>
                <th>{this.intlMsg.msg('addrlist.appskey')}</th>
                <th>{this.intlMsg.msg('addrlist.nwkskey')}</th>
                <th>{this.intlMsg.msg('addrlist.band')}</th>
                <th>RX2DR</th>
                <th>RX2 Frequency</th>
                <th>{this.intlMsg.msg('addrlist.fcntdown')}</th>
                <th>{this.intlMsg.msg('addrlist.operation')}</th>
              </tr>
            </thead>
            <tbody>
              {this.renderRows(list)}
            </tbody>
          </Table>
          <ShowIf if={list.length === 0}>
            <div className={styles.noData}>{this.intlMsg.msg('addrlist.nodata')}</div>
          </ShowIf>
        </Panel>
        <AddAddress
          showModal={showModal}
          appId={appId}
          onHide={() => this.setState({ showModal: false })}
          onSuccess={b => this.handleAdd(b)}
        />
        <EditAddress
          showModal={showEditModal}
          appId={appId}
          onHide={() => this.setState({ showEditModal: false })}
          onSuccess={() => this.handleEdit()}
          data={editObj}
        />
        <DeleteModal
          showModal={showDeleteModal}
          headerText="删除广播地址"
          text={`确认删除广播地址${deleteAddr.name}(${deleteAddr.devaddr})?`}
          onCancel={() => this.setState({ showDeleteModal: false })}
          onConfirm={() => this.handleDelete()}
        />
      </div>
    );
  }
}

AddrList.propTypes = propTypes;

const mapStateToProps = state => ({
  broadcastState: state.broadcast.getBroadcast,
});

const mapDispatchToProps = {
  getBroadcast: broadcastActions.getBroadcast,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(AddrList));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/BroadcastView/coms/AddrList/index.jsx